import React, { createContext, useContext, useState, useEffect } from 'react';
import { translate } from '../i18n';

const STORAGE_KEY = 'learnwithinfobloom_language';

export const LANGUAGES = [
  { code: 'en', name: 'English' },
  { code: 'es', name: 'Español' },
  { code: 'fr', name: 'Français' },
  { code: 'de', name: 'Deutsch' },
  { code: 'pt', name: 'Português' },
  { code: 'zh', name: '中文' },
  { code: 'ja', name: '日本語' },
  { code: 'ko', name: '한국어' },
  { code: 'ar', name: 'العربية' },
  { code: 'hi', name: 'हिन्दी' },
  { code: 'it', name: 'Italiano' },
  { code: 'nl', name: 'Nederlands' },
  { code: 'pl', name: 'Polski' },
  { code: 'ru', name: 'Русский' },
  { code: 'tr', name: 'Türkçe' },
  { code: 'vi', name: 'Tiếng Việt' },
  { code: 'th', name: 'ไทย' },
  { code: 'id', name: 'Bahasa Indonesia' },
];

const defaultLanguage = LANGUAGES[0];

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(defaultLanguage);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        const parsed = JSON.parse(stored);
        const found = LANGUAGES.find((l) => l.code === parsed.code);
        if (found) setLanguageState(found);
      }
    } catch (_) {
      // keep default
    }
  }, []);

  useEffect(() => {
    document.documentElement.lang = language.code || 'en';
  }, [language.code]);

  const setLanguage = (lang) => {
    const found = LANGUAGES.find((l) => l.code === lang.code || l === lang);
    const next = found || (typeof lang === 'object' ? lang : defaultLanguage);
    setLanguageState(next);
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ code: next.code, name: next.name }));
    } catch (_) {}
  };

  const t = (key) => translate(language.code, key);

  return (
    <LanguageContext.Provider value={{ language, setLanguage, languages: LANGUAGES, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
}

